import escapeRegExp from 'lodash.escaperegexp';
/**
 * EnsureObjectOfRegExps.
 *
 * @param object  - { [index: string]: string|RegExp }.
 * @param options - Object.
 * @param options.insensitive - String.
 * @returns - Record<string, string|RegExp>.
 */
export default function ensureObjectOfRegExps(object, options) {
    const { insensitive } = options;
    const toReturn = {};
    for (const [key, value] of Object.entries(object)) {
        if (value instanceof RegExp) {
            toReturn[key] = value;
        }
        else {
            toReturn[key] = new RegExp(`(^|\\.)${escapeRegExp(value)}(\\.|$)`, insensitive);
        }
    }
    return toReturn;
}
//# sourceMappingURL=ensureObjectOfRegExps.js.map